import React, {useEffect, useState} from "react";
import {useSearchParams} from "react-router-dom";
import {FaTimes, FaPlus, FaGift, FaLock} from "react-icons/fa";
import {motion} from "framer-motion";
import {GoChevronDown} from "react-icons/go";
import {GoChevronUp} from "react-icons/go";
import ProfileService from "../../../services/Profile";
import {FaTrash} from "react-icons/fa6";
import {
    FaCoins,
    FaBitcoin,
    FaDollarSign,
    FaTrophy,
    FaGem,
    FaChartLine,
    FaRocket,
    FaCrown,
    FaBolt,
    FaStar,
} from "react-icons/fa6";
import {IoDiamond} from "react-icons/io5";

export default function PackageModal({onSelected, setIsPremiumSignal}) {
    const [searchParams] = useSearchParams();
    const openModalParam = searchParams.get("openCreatePackage") === "true";
    useEffect(() => {
        if (openModalParam) {
            setOpenCreatePackage(true);
        }
    }, [openModalParam]);

    const badgeOptions = [
        {key: "New", label: "New", color: "bg-blue-500"},
        {key: "Hot", label: "Hot", color: "bg-rose-500"},
        {key: "pro", label: "Pro", color: "bg-purple-500"},
        {key: "fast", label: "Fast", color: "bg-emerald-500"},
        {key: "popular", label: "Popular", color: "bg-orange-500"},
        {key: "Free", label: "Free", color: "bg-green-500"},
        {key: "Mix", label: "Mix", color: "bg-indigo-500"},
        {key: "Crypto", label: "Crypto", color: "bg-amber-500"},
    ];

    const iconOptions = [
        {
            key: "coins",
            label: "coins",
            icon: <FaCoins size={20} className="text-yellow-500"/>,
        },
        {
            key: "bitcoin",
            label: "bitcoin",
            icon: <FaBitcoin size={20} className="text-orange-500"/>,
        },
        {
            key: "dollar",
            label: "dollar",
            icon: <FaDollarSign size={20} className="text-green-500"/>,
        },
        {
            key: "crown",
            label: "crown",
            icon: <FaCrown size={20} className="text-yellow-600"/>,
        },
        {
            key: "rocket",
            label: "rocket",
            icon: <FaRocket size={20} className="text-red-500"/>,
        },
        {
            key: "trophy",
            label: "trophy",
            icon: <FaTrophy size={20} className="text-yellow-500"/>,
        },
        {
            key: "gem",
            label: "gem",
            icon: <IoDiamond size={20} className="text-blue-500"/>,
        },
        {
            key: "star",
            label: "star",
            icon: <FaStar size={20} className="text-yellow-400"/>,
        },
    ];
    const [badge, setBadge] = useState();
    const [icon, setIcon] = useState();

    const [openCreatePackage, setOpenCreatePackage] = useState(false);
    const [durations, setDurations] = useState([]);
    const [packages, setPackages] = useState([]);

    const formatPrice = (price) => {
        if (price === "free" || price === 0) return "Free";
        if (!price) return "";

        const numPrice = typeof price === "string" ? parseInt(price) : price;
        return numPrice.toLocaleString();
    };

    const getPackageIcon = (pkg) => {
        const name = pkg?.name?.toLowerCase() || "";

        if (name.includes("golden")) {
            return {
                icon: <FaChartLine className="text-2xl text-white"/>,
                bg: "bg-gradient-to-br from-amber-400 to-orange-500",
            };
        }
        if (name.includes("silver")) {
            return {
                icon: <FaRocket className="text-2xl text-white"/>,
                bg: "bg-gradient-to-br from-blue-400 to-indigo-500",
            };
        }
        if (name.includes("platinum")) {
            return {
                icon: <FaCrown className="text-2xl text-white"/>,
                bg: "bg-gradient-to-br from-purple-400 to-pink-500",
            };
        }
        if (name.includes("scalping")) {
            return {
                icon: <FaBolt className="text-2xl text-white"/>,
                bg: "bg-gradient-to-br from-emerald-400 to-teal-500",
            };
        }

        return {
            icon: <FaStar className="text-2xl text-white"/>,
            bg: "bg-gradient-to-br from-gray-400 to-gray-500",
        };
    };

    useEffect(() => {
        const getAlllDurations = async () => {
            try {
                const response = await ProfileService.getAllDurations();
                setDurations(response?.data?.data);
                console.log("durations", response?.data?.data);
            } catch (error) {
                console.error("Error fetching durations:", error);
                setDurations([]);
            }
        };

        getAlllDurations();
    }, []);

    // بستن dropdown ها هنگام کلیک خارج از آن‌ها
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (!event.target.closest(".dropdown-container")) {
                setDurationDropdownOpen(false);
                setPriceDropdownOpen(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const [form, setForm] = useState({
        name: "",
        description: "",
        duration: "",
        price: "",
        image: "",
    });

    const [durationDropdownOpen, setDurationDropdownOpen] = useState(false);
    const [priceDropdownOpen, setPriceDropdownOpen] = useState(false);

    const priceOptions = [
        {value: "0", label: "Free"},
        {value: "100000", label: "100,000 USDT"},
        {value: "200000", label: "200,000 USDT"},
        {value: "500000", label: "500,000 USDT"},
        {value: "1000000", label: "1,000,000 USDT"},
        {value: "2000000", label: "2,000,000 USDT"},
        {value: "5000000", label: "5,000,000 USDT"},
    ];

    const handleChange = (e) => {
        const {id, value} = e.target;

        let processedValue = value;
        if (id === "price" && value !== "free" && value !== "") {
            processedValue = parseInt(value, 10);
        }

        setForm({...form, [id]: processedValue});
    };

    // const handleImageUpload = async (e) => {
    //     const file = e.target.files[0];
    //     if (!file) return;
    //
    //     const formData = new FormData();
    //     formData.append("file", file);
    //
    //     try {
    //         const response = await FileService.uploadFile(formData);
    //         console.log("File uploaded successfully:", response);
    //         setForm({
    //             ...form,
    //             image: {
    //                 id: response.data.message._id,
    //                 path: `https://api.7-trade.ir/${response.data.message.path}`,
    //             },
    //         });
    //     } catch (error) {
    //         console.error("Error uploading file:", error);
    //     }
    // };

    const resetForm = () => {
        setForm({
            name: "",
            description: "",
            duration: "",
            price: "",
            image: "",
        });
    };

    const handleSubmit = () => {
        setOpenCreatePackage(false);
        handleCreatePackage();
    };

    const [isOpen, setIsOpen] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [selectedPackage, setSelectedPackage] = useState(null);

    const openModal = () => {
        setShowModal(true);
        setTimeout(() => {
            setIsOpen(true);
        }, 300);
    };
    const closeModal = () => {
        setShowModal(false);
        setTimeout(() => {
            setIsOpen(false);
        }, 300);
    };

    const handlePackageSelect = (pkg) => {
        onSelected(pkg);
        setSelectedPackage(pkg);
        closeModal();
    };

    useEffect(() => {
        if (isOpen) {
            const fetchMyPackages = async () => {
                try {
                    const res = await ProfileService.getMyPackages();
                    if (res.data.success) {
                        setPackages(res.data.data || []);
                    } else {
                        setPackages([]);
                        console.log(res.data.message_en || "No packages found");
                    }
                } catch (err) {
                    console.error("Error fetching my packages:", err);
                    setPackages([]);
                    if (err.response?.status === 401) {
                        alert("Please login again");
                    }
                }
            };

            fetchMyPackages();
        }
    }, [isOpen]);

    const handleCreatePackage = async () => {
        const body = {
            name: form?.name,
            price: Number(form?.price),
            duration: form?.duration,
            description: form?.description,
            packageIcon: icon,
            packageBadge: badge,
            packageFeatures: featureValues,
        };

        console.log("creating package:", body);

        try {
            const response = await ProfileService.createPackage(body);
            console.log("Package created successfully:", response);
            resetForm();
        } catch (error) {
            console.error("Error creating package:", error);
        }
    };
    const [active, setActive] = useState(null);

    const [features, setFeatures] = useState([{id: 1}]);

    const addFeature = () => {
        if (features.length < 5) {
            setFeatures((prev) => [...prev, {id: prev.length + 1}]);
        }
    };

    const removeFeature = (index) => {
        setFeatures((prev) => prev.filter((_, i) => i !== index));
    };

    const [featureValues, setFeatureValues] = useState([""]);

    return (
        <>
            <div
                className="w-full min-h-[250px] bg-white shadow-lg rounded-[12px] p-6 flex flex-col justify-start items-start gap-2">
                <p className="text-[18px] leading-3 font-bold text-center h-[28px]">
                    Select Package
                </p>
                <div
                    onClick={openModal}
                    className="w-full relative mb-3 h-[60px] border-solid border-2 border-[#D1D5DB] bg-white rounded-[8px] flex flex-row px-5 justify-between gap-2 items-center"
                >
                    <p className="text-gray-500 ">
                        {selectedPackage ? selectedPackage.name : "Choose a package..."}
                    </p>
                    {isOpen ? (
                        <GoChevronUp
                            size={20}
                            className="absolute right-2 to-5 text-gray-700"
                        ></GoChevronUp>
                    ) : (
                        <GoChevronDown
                            size={20}
                            className="absolute right-2 to-5 text-gray-700"
                        ></GoChevronDown>
                    )}
                </div>
                <p className="text-[18px] leading-3 font-bold text-center h-[28px]">
                    Signal Type
                </p>
                <div className="flex w-[100%] gap-2">
                    <button
                        onClick={() => {
                            setActive("free");
                            setIsPremiumSignal(false);
                        }}
                        className={`
                              flex w-full text-center p-3 justify-center border-2 rounded-lg font-semibold
                              ${
                            active === "free"
                                ? "border-green-600 text-green-600 bg-green-50 hover:bg-green-100"
                                : "border-gray-200 text-gray-500 bg-gray-50 hover:bg-gray-100"
                        }
                              transition-colors
                            `}
                    >
                        <FaGift className="mr-3 mt-0.5"></FaGift>
                        Free
                    </button>
                    <button
                        onClick={() => {
                            setActive("premium");
                            setIsPremiumSignal(true);
                        }}
                        className={`
                              flex w-full text-center p-3 justify-center border-2 rounded-lg font-semibold
                              ${
                            active === "premium"
                                ? "border-amber-500 text-amber-600 bg-amber-50 hover:bg-amber-100"
                                : "border-gray-200 text-gray-500 bg-gray-50 hover:bg-gray-100"
                        }
                              transition-colors
                            `}
                    >
                        <FaCrown className="mr-3 mt-0.5"></FaCrown>
                        Premium
                    </button>
                </div>
                {active === "premium" &&
                    <motion.div
                        key="premium"
                        initial={{ opacity: 0, y: -35, scale: 0.98 }}
                        animate={{ opacity: 1, y: 0, scale: 1 }}
                        exit={{ opacity: 0, y: -20, scale: 0.98 }}
                        transition={{
                            type: "spring",
                            stiffness: 260,
                            damping: 24,
                        }}
                        className="bg-gray-100 rounded-2xl py-10 px-6 text-center mb-4 w-full"
                    >
                        <div className="flex justify-center mb-5">
                            <div className="w-20 h-20 rounded-full bg-gray-200 flex items-center justify-center">
                                <FaLock className="text-4xl text-gray-500" />
                            </div>
                        </div>

                        <h3 className="text-2xl font-bold text-gray-900">
                            Subscribe to unlock
                        </h3>

                        <p className="mt-3 text-gray-500 text-lg">
                            Get access to all premium signals
                        </p>
                    </motion.div>
                }
            </div>

            {isOpen && (
                <div
                    className={`fixed inset-0 bg-black/50 popup-overlay z-50 flex items-end `}
                >
                    <div
                        className={`bg-white rounded-t-xl w-full max-h-[80vh] overflow-hidden transform transition-transform duration-300 translate-y-0 ${
                            showModal ? "animate-slideOutToUp" : "animate-slideOutToBottom"
                        }`}
                    >
                        {/* Header */}
                        <div className="p-5 border-b border-gray-200 flex items-center justify-between">
                            <h3 className="font-bold text-lg">Select Package</h3>
                            <button onClick={closeModal} className="text-secondary">
                                <FaTimes className="text-xl"/>
                            </button>
                        </div>

                        <div className="p-5 overflow-y-auto max-h-[60vh] space-y-3">
                            <button
                                onClick={() => {
                                    setOpenCreatePackage(true);
                                    closeModal();
                                }}
                                className="w-full p-4 border-2 border-dashed border-primary rounded-lg text-primary font-semibold hover:bg-light transition flex items-center justify-center"
                            >
                                <FaPlus className="mr-2"/>
                                Create New Package
                            </button>

                            {/* Existing Packages */}
                            {packages.map((pkg) => {
                                const packageIcon = getPackageIcon(pkg);
                                return (
                                    <div
                                        key={pkg._id}
                                        onClick={() => handlePackageSelect(pkg)}
                                        className="package-option p-4 border border-gray-200 rounded-lg cursor-pointer hover:border-primary transition flex items-center space-x-3"
                                    >
                                        <div
                                            className={`w-12 h-12 rounded-lg flex items-center justify-center ${packageIcon.bg}`}
                                        >
                                            {pkg?.packageIcon === "coins" ? (
                                                <FaCoins className="text-2xl text-white"/>
                                            ) : pkg?.packageIcon === "bitcoin" ? (
                                                <FaBitcoin className="text-2xl text-white"/>
                                            ) : pkg?.packageIcon === "dollar" ? (
                                                <FaDollarSign className="text-2xl text-white"/>
                                            ) : pkg?.packageIcon === "crown" ? (
                                                <FaCrown className="text-2xl text-white"/>
                                            ) : pkg?.packageIcon === "rocket" ? (
                                                <FaRocket className="text-2xl text-white"/>
                                            ) : pkg?.packageIcon === "trophy" ? (
                                                <FaTrophy className="text-2xl text-white"/>
                                            ) : pkg?.packageIcon === "gem" ? (
                                                <FaGem className="text-2xl text-white"/>
                                            ) : pkg?.packageIcon === "star" ? (
                                                <FaStar className="text-2xl text-white"/>
                                            ) : null}
                                        </div>
                                        <div className="flex-1">
                                            <h4 className="font-semibold">{pkg.name}</h4>
                                            <p className="text-sm text-secondary">
                                                {pkg.price === "free" || pkg.price === 0
                                                    ? "Free"
                                                    : `${formatPrice(pkg.price)}/Month`}
                                            </p>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </div>
            )}

            {openCreatePackage && (
                <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-end justify-center">
                    <div className="bg-white rounded-t-xl w-full max-h-[90vh] overflow-hidden animate-slideOutToUp">
                        {/* Header */}
                        <div className="p-5 border-b border-gray-200 flex items-center justify-between">
                            <h3 className="font-bold text-lg">Create New Package</h3>
                            <button
                                onClick={() => {
                                    setOpenCreatePackage(false);
                                    resetForm();
                                }}
                                className="text-secondary"
                            >
                                <FaTimes className="text-xl"/>
                            </button>
                        </div>

                        {/* Body */}
                        <div className="p-5 overflow-y-auto max-h-[75vh] space-y-4">
                            {/* Package Name */}
                            <div>
                                <label className="block font-semibold mb-2">Package Name</label>
                                <input
                                    type="text"
                                    id="name"
                                    value={form.name}
                                    onChange={handleChange}
                                    placeholder="Enter package name"
                                    className="w-full p-3 border border-gray-300 rounded-lg focus:border-primary focus:outline-none"
                                />
                            </div>

                            <div>
                                <div>
                                    <label className="block font-semibold mb-2">
                                        Package Icon
                                    </label>
                                    <div className="grid grid-cols-5 gap-3">
                                        {iconOptions.map((item) => (
                                            <button
                                                key={item.key}
                                                onClick={() => setIcon(item.key)}
                                                className={`package-badge-option w-full aspect-square border-2 rounded-xl flex items-center justify-center transition-all duration-200 overflow-hidden hover:scale-105
                          ${
                                                    icon === item.key
                                                        ? "border-primary"
                                                        : "border-gray-200"
                                                }`}
                                            >
                        <span
                            className={`text-xs font-bold text-white px-2 py-1 rounded-md`}
                        >
                          {item.icon}
                        </span>
                                            </button>
                                        ))}
                                    </div>
                                </div>
                            </div>

                            <div>
                                <div>
                                    <label className="block font-semibold mb-2">
                                        Package Badge
                                    </label>
                                    <div className="grid grid-cols-5 gap-3">
                                        {badgeOptions.map((item) => (
                                            <button
                                                key={item.key}
                                                onClick={() => setBadge(item.key)}
                                                className={`package-badge-option w-full aspect-square border-2 rounded-xl flex items-center justify-center transition-all duration-200 overflow-hidden hover:scale-105
                          ${
                                                    badge === item.key
                                                        ? "border-primary"
                                                        : "border-gray-200"
                                                }`}
                                            >
                        <span
                            className={`text-xs font-bold text-white px-2 py-1 rounded-md ${item.color}`}
                        >
                          {item.label}
                        </span>
                                            </button>
                                        ))}
                                    </div>
                                </div>
                            </div>

                            {/* Package Description */}
                            <div>
                                <label className="block font-semibold mb-2">Description</label>
                                <textarea
                                    id="description"
                                    value={form.description}
                                    onChange={handleChange}
                                    placeholder="Enter package description"
                                    rows="3"
                                    className="w-full p-3 border border-gray-300 rounded-lg focus:border-primary focus:outline-none resize-none"
                                />
                            </div>

                            {/* [EDIT] JSX Feature List */}
                            <div>
                                <div className="flex items-center justify-between mb-3">
                                    <label className="block font-semibold">
                                        Package Features
                                    </label>
                                    <button
                                        onClick={addFeature}
                                        className="bg-green-100 text-green-700 px-3 py-2 rounded-lg text-sm font-semibold"
                                    >
                                        <i className="fa-solid fa-plus mr-1"></i> Add Feature
                                    </button>
                                </div>

                                <div className="space-y-3">
                                    {features.map((_, index) => (
                                        <div
                                            key={index}
                                            className="feature-item flex items-center space-x-3"
                                        >
                      <span
                          className="bg-primary/10 text-primary w-8 h-8 rounded-full flex items-center justify-center text-sm font-bold flex-shrink-0">
                        {index + 1}
                      </span>

                                            <input
                                                type="text"
                                                placeholder={`Feature ${index + 1}`}
                                                onChange={(e) => {
                                                    const newFeatureValues = [...featureValues];
                                                    newFeatureValues[index] = e.target.value;
                                                    setFeatureValues(newFeatureValues);
                                                }}
                                                className="flex-1 p-3 border border-gray-300 rounded-lg focus:border-primary focus:outline-none"
                                            />

                                            <button
                                                onClick={() => removeFeature(index)}
                                                className="remove-feature text-red-500 p-2"
                                            >
                                                <FaTrash/>
                                            </button>
                                        </div>
                                    ))}
                                </div>
                            </div>

                            {/* Duration */}
                            <div className="relative dropdown-container">
                                <label className="block font-semibold mb-2">Duration</label>
                                <div
                                    onClick={() => setDurationDropdownOpen(!durationDropdownOpen)}
                                    className="w-full p-3 border border-gray-300 rounded-lg cursor-pointer flex justify-between items-center hover:border-primary transition"
                                >
                  <span
                      className={form.duration ? "text-black" : "text-gray-500"}
                  >
                    {form.duration
                        ? durations.find((d) => d._id === form.duration)?.days +
                        " days"
                        : "Select duration"}
                  </span>
                                    {durationDropdownOpen ? <GoChevronUp/> : <GoChevronDown/>}
                                </div>

                                {durationDropdownOpen && (
                                    <div
                                        className="absolute z-10 w-full mt-1 bg-white border border-gray-300 rounded-lg shadow-lg max-h-48 overflow-y-auto">
                                        <div
                                            onClick={() => {
                                                setForm({...form, duration: ""});
                                                setDurationDropdownOpen(false);
                                            }}
                                            className="p-3 hover:bg-gray-50 cursor-pointer text-gray-500"
                                        >
                                            Select duration
                                        </div>
                                        {durations.map((duration) => (
                                            <div
                                                key={duration._id}
                                                onClick={() => {
                                                    setForm({...form, duration: duration._id});
                                                    setDurationDropdownOpen(false);
                                                }}
                                                className="p-3 hover:bg-gray-50 cursor-pointer"
                                            >
                                                {duration.days} days
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>

                            {/* Price */}
                            <div className="relative dropdown-container">
                                <label className="block font-semibold mb-2">Price</label>
                                <div
                                    className="relative w-full border border-gray-300 rounded-lg cursor-pointer flex justify-between items-center hover:border-primary transition">
                                    <input
                                        value={form.price + " USDT"}
                                        onChange={(e) =>
                                            setForm({...form, price: e.target.value})
                                        }
                                        className=" w-full p-3 border border-transparent rounded-lg focus:border-primary focus:outline-none"
                                        placeholder="Select price"
                                        onClick={() => setPriceDropdownOpen((prev) => !prev)}
                                    />
                                    <span className="absolute right-3 top-1/2 transform -translate-y-1/2">
                    {priceDropdownOpen ? <GoChevronUp/> : <GoChevronDown/>}
                  </span>
                                    {priceDropdownOpen && (
                                        <div
                                            className="absolute z-10 w-full top-12 mt-1 bg-white border border-gray-300 rounded-lg shadow-lg max-h-48 overflow-y-auto">
                                            <div
                                                onClick={() => {
                                                    setForm({...form, price: ""});
                                                    setPriceDropdownOpen(false);
                                                }}
                                                className="p-3 hover:bg-gray-50 cursor-pointer text-gray-500"
                                            >
                                                Select price
                                            </div>
                                            {priceOptions.map((option) => (
                                                <div
                                                    key={option.value}
                                                    onClick={() => {
                                                        setForm({...form, price: option.value});
                                                        setPriceDropdownOpen(false);
                                                    }}
                                                    className="p-3 hover:bg-gray-50 cursor-pointer"
                                                >
                                                    {option.label}
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </div>
                            </div>

                            {/* Actions */}
                            <div className="flex space-x-3 pt-4">
                                <button
                                    onClick={() => {
                                        setOpenCreatePackage(false);
                                        resetForm();
                                    }}
                                    className="flex-1 p-3 border border-gray-300 rounded-lg text-secondary font-semibold"
                                >
                                    Cancel
                                </button>
                                <button
                                    onClick={handleSubmit}
                                    className="flex-1 p-3 bg-primary text-white rounded-lg font-semibold"
                                >
                                    Create Package
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}
